// export const controls = [
//   {
//     name: "常用控件",
//     options: ["文本", "数值", "文本", "数值", "文本", "数值", "文本", "数值", "文本", "数值"]
//   },
//   {
//     name: "高级控件",
//     options: ["关联表", "计算", "关联表", "计算", "关联表", "计算", "关联表", "计算"]
//   },
//   {
//     name: "特殊控件",
//     options: ["备注", { name: "分组", type: "fieldsGroup" }]
//   }
// ]

export const groupControl = [
  { name: "分组", type: "fieldsGroup", data: { name: "新建分组", fields: [] } }
  // { name: "分组", type: "fieldsGrid", data: { name: "新建栅格", fields: [] } }
]

export const systemGroup = {
  name: "系统信息",
  fields: [
    { name: "创建人", _cid: "cid", value: "creator", _type: "staff" },
    { name: "创建时间", _cid: "cat", value: "createAt", _type: "time", timeType: "年月日时分秒" },
    { name: "最后修改人", _cid: "upid", value: "updateUser", _type: "staff" },
    {
      name: "最后修改时间",
      _cid: "uat",
      value: "updateAt",
      _type: "time",
      timeType: "年月日时分秒"
    },
    { name: "负责人", _cid: "oid", value: "owner", _type: "staff" }
  ]
}
